<div class="wallet-trend-container" id="wallet-trend-container">
  <!-- Header with back button -->
  <div class="header-section" id="wallet-trend-header">
    <app-link (click)="onBackClick()" icon="arrow_back" i18n="@@goBack" id="wallet-trend-link-back">Volver</app-link>

    <h3 class="page-title" id="wallet-trend-title">
      <span i18n="@@walletTrendTitle">Análisis de tendencia de la cartera</span>
    </h3>
  </div>

  <div class="subtitle-section" id="wallet-trend-subtitle">
    <span i18n="@@walletTrendDescription" id="wallet-trend-span-desc">
      Visualice a continuación la variación de un índice específico, filtrando un atributo y el
      período de análisis.
    </span>
    <span id="wallet-trend-span-wallet"> <b i18n="@@wallet">Cartera:</b> {{ wallet().name }} </span>
  </div>

  <div class="filters-section" id="wallet-trend-filters">
    <app-select
      id="wallet-trend-select-indicator"
      titleLabel="Índice para análisis"
      i18n-titleLabel="@@indiceForAnalysis"
      titleIcon="circle_icon_outlined"
      style="min-width: 300px; max-width: 400px; width: 100%"
      [options]="facade.indicators()"
      [optionLabelFn]="optionLabelFn"
      [disabled]="isLoading()"
      [isLoading]="facade.isLoadingIndicators()"
      [loadingText]="loadingIndicatorsText"
      [ngModel]="facade.selectedIndicator()"
      (ngModelChange)="onIndicatorSelect($event)"
      (titleIconClick)="openAttributeInfoModal()"
      placeholder="Seleccione un indicador"
      i18n-placeholder="@@selectIndicator"
    ></app-select>

    <app-date-range
      id="wallet-trend-daterange-period"
      style="width: 330px"
      [minDate]="walletCreationDate()"
      [maxDate]="maxDate"
      [mode]="'monthYear'"
      [disabled]="isLoading()"
      titleLabel="Periodo de análisis"
      i18n-titleLabel="@@analysisPeriod"
      [infoLabel]="'MM/AAAA - MM/AAAA'"
      (startDateChange)="onStartDateChange($event)"
      (endDateChange)="onEndDateChange($event)"
    ></app-date-range>
  </div>

  <div class="chart-section" id="wallet-trend-chart-section">
    @if (facade.isLoadingChart()) {
      <div class="loading-container" id="wallet-trend-loading">
        <app-ellipsis-loading id="wallet-trend-ellipsis-loading"></app-ellipsis-loading>
      </div>
    }

    @if (facade.error()) {
      <div class="error-state" id="wallet-trend-error-state">
        <img src="assets/images/danger.svg" alt="Error" id="wallet-trend-img-error" />
        <span i18n="@@errorRetrievingData" id="wallet-trend-span-error">Error al intentar recuperar los datos.</span>
      </div>
    } @else {
      @if (!isLoading() && facade.chartData().data?.values?.length > 0 && chartOptions()) {
        <div class="chart-container" id="wallet-trend-chart-container">
          <app-chart-cl
            id="wallet-trend-chart"
            [labels]="facade.chartData().labels"
            [data]="facade.chartData().data?.values"
            [type]="'line'"
            [backgroundColor]="'#42A5F5'"
            [borderColor]="'#42A5F5'"
            [borderWidth]="3"
            [pointRadius]="6"
            [animationDuration]="1300"
            [animationEasing]="'easeInOutCubic'"
            [datasetLabel]="
              facade.chartData().data?.label || facade.selectedIndicator()?.displayLabel || 'Índice'
            "
            [customChartOptions]="chartOptions()"
          ></app-chart-cl>
        </div>
      }

      @if (!isLoading() && facade.hasSearched() && facade.chartData().data.values.length === 0) {
        <div class="no-data-container" id="wallet-trend-no-data">
          <img src="assets/images/warning.svg" alt="Warning" id="wallet-trend-img-warning-nodata" />
          <span i18n="@@noDataDisplay" id="wallet-trend-span-nodata">No hay datos para mostrar.</span>
        </div>
      }

      @if (!facade.isLoadingChart() && !facade.hasSearched() && !canLoadData()) {
        <div class="empty-state" id="wallet-trend-empty-state">
          <img src="assets/images/warning.svg" alt="Warning" id="wallet-trend-img-warning-empty" />
          <span i18n="@@selectAttributeAndPeriod" id="wallet-trend-span-empty">
            Seleccione un atributo y el período para ver el gráfico.
          </span>
        </div>
      }
    }
  </div>
</div>

<ng-template #attributeInfoContent>
  <div id="wallet-trend-attr-info-content">
  <p i18n="@@walletIndicaModalDescription" id="wallet-trend-p-desc">
    Representa a relação entre o volume de um determinado restritivo e o tamanho da carteira.
    Permite comparar o risco real entre carteiras de tamanhos diferentes.
  </p>
  <p i18n="@@formulaLabel" style="font-weight: 600; font-size: 0.875rem; padding-top: 16px" id="wallet-trend-p-formula-label">
    Fórmula:
  </p>
  <p i18n="@@ocurrencesTotalPlusDocumentsTotal" style="font-weight: 600; font-size: 0.875rem" id="wallet-trend-p-formula">
    (Total de ocurrencias) ÷ (Total de documentos).
  </p>
  </div>
</ng-template>
